module.exports = __webpack_public_path__ + "img/singapore.c18b9d8.svg";